export const defaults = {
  //labels
  cancleBtn: "Cancel",
  continueBtn: "Continue",
  chooseLocation: "Choose Location",
  tryAgainBtn: "Try Again",
  submit: "Submit",
  topUpSubmitBtn: "Top Up",
  payNowBtn: "Pay Now",
  okayBtn: "Okay",
  viewRequests: "Track Request",
  edit: "Edit",
  update: "Update",
  outOf: "out of",
  accessories: "Gas Accessories",

  //SiginIn
  welcomeLabel: "Welcome,",
  loginToContinue: "Log in to continue.",
  logInTxt: "Log In",
  donotHaveAcc: "Don't have an account?",
  signUpTxt: "Sign Up",
  poweredBy: "Powered by Sayagie",
  signUpWithPhoneLabel: "Sign up with Phone",

  //SignUp
  phoneNumberTxt: "Please enter your phone number",
  signUpNxt: "Next",

  //Profile Menu
  profileLabel: "Profile",
  financeLabel: "Finance",
  withdrawalLabel: "Withdrawal Requests",
  accountSettingsLabel: "Account Settings",
  withdrawalAccountsLabel: "Withdrawal Accounts",
  faqLabel: "FAQs",
  savedCardLabel: "Saved Accounts",
  myReviewsLabel: "My Reviews",

  logoutConfirmation: "Are you sure you want to logout?",

  //Profile
  lastNameLabel: "Last Name",

  //Home Page
  okayText: "Okay",
  invalidLocationModalTitle: "No Supplier available",
  invalidLocationText:
    "Unfortunately, we are not operating in your area for now. Contact our team for more details.",

  noAvailableSupplier: "No Supplier available",
  noSupplierModalText: "There is no supplier in your defined radius.",

  navigateToNearestSupplierLabel:
    "There is no supplier in your defined radius. Should we navigate your location to the nearest supplier?",

  backToMapViewLabel: "Back to Map View",

  // Home - Filters
  purchaseTypeLabel: "Purchase Type",
  cylinderTypeLabel: "Cylinder Type",
  volumeLabel: "Volume",
  radiusLabel: "Radius",
  minRangeLabel: "min",
  maxRangeLabel: "max",
  priceLabel: "Price",

  filtersLabel: "Filters",
  filterSaveText: "Apply",

  yesLabel: "Yes",
  noLabel: "No",

  showLabel: "Show",
  clearAll: "Clear All",
  reviewsLabel: "Reviews",
  backLabel: "Back",

  noResultsLabel: "Oops! No results match your filters",
  noSupplierFound: "No Supplier Found",

  //Finance

  walletLabel: "Wallets",
  currentBlnc: "Current Balance",
  withdrawBtn: "Withdraw",
  topUpBtn: "Top-Up",
  bankAccountLabel: "Settlement Accounts",
  bankAccountBtn: "Add Account",
  transactionHistory: "Transaction History",
  transactionId: "Transaction ID",
  transactionSource: "Source",
  transactionTime: "Date & Time",
  transactionAmount: "Amount",
  currencyNotSupported: "Currency Not Supported",
  bankaccount: "Add Account Details",
  topup: " Add Top Up Amount",
  withdrawal: " Add Withdrawal Amount",
  doesNotExist: "Could not resolve account!",
  unableToAddAccTitle: "Unable to add Bank Account",
  unableToAddAccContent:
    "Unable to fetch bank account details. Please check account number and try again. Contact your bank if issue persists. You can contact our support team in case of any query.",
  accountNumber: "Account Number",
  accountName: "Account Name",
  noTransaction: "No Transaction",
  currentBalance: "Current Balance",
  withdrawalSent: "Withdrawal Request Sent",
  withdrawalSentContent:
    "Your withdrawal request has been sent successfully. Check your request status in profile.",
  detailConfirm: "Please confirm your details below.",
  noWallet: "No Wallet Exists",
  bankAccAddedTitle: "Bank Account Added",
  bankAccAddedContent: "Your bank account has been successfully added.",
  verifyAccountDetail: "Verify Account Details",
  withdrawalRequestSent: "Withdrawal Request Sent",
  bankAccAdded: "Bank Account Added",
  transactionFeeTitle: "Transaction Fee",
  feeTitle: "Fee",
  withDrawalAccountsList: "Withdrawal Accounts",
  transactionPurpose: "Transaction Purpose",
  selectToContinue: "Please select bank to continue",

  topupSuccessTitle: "Top-up Successful",
  successfulTopupLabel: "Your wallet has been successfully recharged",

  //Withdrawal Requests

  withdrawalRequests: "Withdrawal Requests",
  noWithdrawalRequests: "No Requests", // *Update
  widthdrawalStatus: "Status",
  withdrawalRequestId: "Request ID",
  withdrawalAmount: "Withdrawal Amount",
  withdrawalRequestDateAndTime: "Request Date & Time",
  noWithdrawalDetail: "No Detail Exists",
  requestDetail: "Request Details",
  requestAccountDetails: "Account Details",
  requestBank: "Bank",
  withdrawalAccountNumber: "Account Number/IBAN",
  withdrawalAccountTitle: "Account Title",
  backToList: "Back to listing",

  // Account Settings
  accountSettings: "Account Settings",
  allowPushNotification: "Allow Push-Notifications",
  deleteAccount: "Delete Account",
  deleteAccountConfirmation: "Are you sure you want delete your account?",
  deleteAccountContent:
    "To complete your account deletion enter the 6-digit code from sms.",
  deleteWaringContent:
    "This will delete all your data in Sapphire, including orders and billing information.",
  deleteLabel: "Delete",

  //Withdrawal Accounts

  noWithdrawalAccount: "No Withdrawal accounts",
  noWithdrawalAccountContent:
    "Once you make any payment from the card, it will be saved over here.",
  deleteBankAccountConfirmation:
    "Are you sure you want delete this bank account?",

  //Saved Cards

  savedCardsLabel: "Saved Cards",
  noSavedCard: "No Saved Cards",
  noSavedCardContent:
    "Once you make any payment from the card, it will be saved over here.",
  deleteCard: "Delete Card",
  deleteCardConfirmation: "Are you sure you want delete this card?",

  // My Reviews
  noMyReviews: "No Reviews",
  noMyReviewsContent: "You haven’t left any feedback yet",
  myReviewStatus: "Status",
  myReviewOrderId: "Order ID",
  myReviewDateAndTime: "Order Date & Time",
  myReviewTotalRating: "Your Overall Rating",
  yourReview: "Your Review",

  // Supplier Details

  viewAllLabel: "View All",
  selectFuleTypeLabel: "Select Fuel Type",
  noProductsforContainerMaterial: "No products for {{}} container material",

  // Supplier Filters
  containerTypesLabel: "Container Types",
  containerOptionsLabel: "Container Options",
  fuelTypesLabel: "Fuel Types",
  containerMaterialLabel: "Container Material",

  countryOfOriginLabel: "Country of Origin",
  containerType: "Contatiner Type",

  addToCartLabel: "Add to Cart",
  outOfStockLabel: "Out of Stock",

  alradyExistInCartLabel: "Already Exists in Cart",

  addToCartSuccessMessage: "Added to Cart Successfully",
  viewCartLabel: "View Cart",

  supplierOfflineLabel: "Supplier is currently offline",
  supplierOfflineDetaiedLabel:
    "Supplier is currently offline. He will respond later to your request",

  // Cart Labels
  myCartLabel: "My Cart",
  emptyCartHeading: "Your Cart is Empty",
  emptyCartDescription: "But it’s never too late to fix it :)",
  moveToHomeLabel: "Move to Home Screen",

  deliveryTypeLabel: "Delivery Type",
  deliveryAddressLabel: "Delivery Address",
  deliveryInformation: "Delivery Information",

  deliveryDate: "Delivery Date",
  deliveryAddress: "Delivery Address",
  deliveryCost: "Delivery Cost",
  deliveryTime: "Delivery Time",
  saveLabel: "Save",
  chooseFromMapLabel: "Choose from Map",
  proceedLabel: "Proceed",
  proceedToPaymentLabel: "Proceed To Payment",
  vatAmountLabel: "VAT Amount",

  cartLimitLabel: "Cart Limit",
  cartLimitErrorMessage: "Can not add more than {{}} items into the cart",

  emptyCartLabel: "Empty Cart",
  emptyCartConfirmationTitle:
    "Can not add products from another supplier, please clear cart before adding this item. Clear Cart?",

  cancelLabel: "Cancel",
  containerOptionLabel: "Container Option",
  emptyAllCartDescription:
    "Are you sure you want to clear all cart of this supplier",
  deleteCartItem: "Delete Cart Item",
  deleteCartItemLabel: "Are you sure you want to delete this item from cart?",

  deliveryTypesLabel: "Delivery Types",
  standardDescription:
    "Want to speed up delivery and receive your order as soon as possible? We can do that for you",
  expressDescription:
    "Want to speed up delivery and receive your order today? We can do that for you",
  freeDescription:
    "Enjoy free delivery, we will deliver this order for free on the supported products",
  scheduledDescription: "Schedule delivery according to your comfort",
  selfPickupDescription: "You can pick up your order yourself",

  deliveryInLabel: "Delivery in -",
  deliveryOnLabel: "Delivery on -",
  deliveryDateAndTimeLabel: "Delivery Date & Time",
  selectTimelineLabel: "Select Timeslot",

  deliveryDateLabel: "Delivery Date",
  deliveryTimeLabel: "Delivery Time",

  addCouponLabel: "Add Coupon",
  applyLabel: "Apply",
  couponCodeLabel: "Coupon Code",
  removeLabel: "Remove",
  orderSummaryLabel: "Order Summary",

  subTotalLabel: "Sub Total",
  discountLabel: "Discount",
  deliveryFeeLabel: "Delivery Fee",
  platformFeeLabel: "Platform Fee",
  taxOrVATLabel: "Tax/VAT",
  paymentMethodsLabel: "Payment Methods",
  couponCardLabel: "Coupon",
  unsupportedProductsMessage:
    "This delivery type is not available for some products",
  couponDiscountLabel: "Coupon Discount",
  deliverIn: "Delivery In",
  productUpdatedLabel: "Product Updated",
  productCartUpdatedMessage:
    "Some products may have been updated by supplier, please reevaluate your cart",

  orderDetailsLabel: "Order Details",
  payableAmountLabel: "Payable Amount",
  choosePaymentMethodLabel: "Choose Payment Method",
  waitingForConfirmation: "Waiting for payment confirmation",
  paymentSuccessfulLabel: "Payment Successful",
  successfulOrderLabel: "Order no. {{}} has been placed successfully.",
  trackOrderLabel: "Track Order",

  paymentFailedLabel: "Payment Failed",
  paymentUnsuccessfulMessage:
    "Your payment could not be processed by the payment gateway, please try again or contact support for recurring issue.",

  tryAgainLabel: "Try Again",

  myOrdersLabel: "My Orders",
  emptyOrderHeading: "No Orders Available!!",
  emptyOrderDescription:
    "Want to order a product? Create the account or sign in.",

  pendingLabel: "Pending",
  processingLabel: "Processing",
  pastLabel: "Past",
  backToSummaryLabel: "Back To Summary",
  reservationExpiryTitle: "Reservation Expired",
  reservationFailureMessage:
    "Your payment could not be processed as reservation time has expired, please reserve your order again from order summary.",
  payNowLabel: "Pay Now",

  walletTitle: "Wallet",
  bankCardLabel: "Bank Card",
  orderReservationMessage: "Complete your order in",
  orderNoLabel: "Order No.",
  viewDetailsLabel: "View Details",

  // Orders
  supplierTitle: "Supplier",
  orderDateTimeLabel: "Order Date & Time",
  deliveryDateTimeLabel: "Delivery Date & Time",
  pickupDateTimeLabel: "Pickup Date & Time",
  paidAmountLabel: "Paid Amount",
  backToOrdersLabel: "Back to orders",
  paymentMethodLabel: "Payment Method",

  walletText: "Wallet",
  paystackText: "Paystack",

  cancelOrderLabel: "Cancel Order",
  contactSupportLabel: "Contact Support",
  reorderLabel: "Reorder",
  cancellationReasonText: "Please enter the cancellation reason.",
  addReviewLabel: "Add Review",

  rateOrderLabel: "Rate Order",
  ratingFieldLabel: "How was your experience?",
  reviewPlaceholder: "Write your review here...",
  reorderConfirmation: "Are you sure you want to reorder?",
  cancelOrderConfirmation: "Are you sure you want to cancel order?",
  writeReviewLabel: "Write a review",
  yourReviewLabel: "Your Review:",
  orderTrackLabel: "Order Track",

  orderPlacedStatusLabel: "Order Placed",
  inProgressLabel: "In Progress",
  orderDispatched: "Out for Delivery",
  orderDeliveredLabel: "Delivered",
  orderRefunded: "Refunded",
  orderRejectedLabel: "Rejected",
  orderCancelledLabel: "Cancelled",
  orderDeclinedLabel: "Declined",
  supplierCancelledOrder: "Supplier has cancelled your order",
  sentYourOrderMessage: "We’ve sent your order",
  confirmedOrderMessage: "Supplier has confirmed your order",
  dispatchedOrderMessage: "Your order is on the way",
  deliveredOrderMessage: "Your order has been delivered",
  rejectedOrderMessage: "Supplier has rejected your order",
  declinedOrderMessage: "Supplier has declined your order",
  orderRefundedMessage: "Supplier has refunded your order",

  // Topup
  topupAmountLabel: "Topup Amount",

  outOfStockMessage: "Product is out of stock, Please reevaluate your cart",

  productUnavailableLabel: "Product Unavailable",
  productUnavailableMessage: "Product is no longer available",
  totalLabel: "Total",
  loginConfirmationMessage: "In order to proceed, you have to login first",
  loginToContinueLabel: "Login to continue",
  placeOrderLabel: "Place Order",
  buyNowLabel: "Buy Now",
  freeLabel: "FREE",
  cashOnDeliveryLabel: "Cash On Delivery",
  noResults: "No Results",
  firstNameLabel: "First Name",
  updateProfileMessage: "Your profile has been successfully updated",
  cylinderVolumeLabel: "Cylinder Volume",
  refillTypeLabel: "Refill Type",
  refillAmountLabel: "Amount",
  refillVolumeLabel: "Refill Volume",
  addMoreLabel: "Add More",
  termsOfRefill: "Terms of Refill Cylinder",
  fillAllDetails: "Please fill all details to continue",
  termsAndConditionsLabel: "Terms and Conditions",
  acceptLabel: "Accept",
  declineLabel: "Decline",
  productCartSuccessMessage: "Product has been added in cart successfully",
  privacyLabel: "Privacy",
  termsLabel: "Terms & Conditions",
  emptyProductHeading: "No Products Available!!",
  uniqueProductError:
    "Can not add more than {{}} items into the cart from same supplier",
  withdrawalRequestDescription:
    "You can make withdrawal request from finance screen.",

  usageTypeLabel: "Usage",
  commercialLabel: "Commercial",
  domesticLabel: "Domestic",

  productDescriptionLabel: "Description",
  accessoriesLabel: "Accessories",
  chooseMaterialLabel: "Choose Material",
  noAccessoriesLabel: "No Accessories",
  noAccessoriesDescription: "There are no accessories available",

  //styles
  grey: "#6B7785",
  black: "#000",

  primaryColor: "#AE6F28",
  primaryBackgroundColor: "#F7F7F9",
  green: "#46E5A3",
  primaryPink: "#FF2F61",
  tileRedColor: "#F25050",

  pink: "#F04971",
  red: "#FA2D3C",
  orange: "#FDB230",
  blue: "#7ABEFD",
  violet: "#C599EA",
  primaryBlack: "#0A0017",

  darkGreen: "#21D187",

  secondaryGray: "#74787C",
  secondaryLightGray: "#728087",
  lightGray: "#CCC",
  darkGray: "#788192",
  slateGray: "#E1E7E7",

  //configs
  imageWidth: 1024,
  imageHeight: 1024,
  maxContainerVolumeFilter: 100,
  minContainerVolume: 3.5,
  maxFileSize: 10,
  maximumFiles: 5,
  priceVAT: 10,
  maxRadiusInKM: 100,
  whatsappSupport: "+233548618018",
  minProductPrice: 0,
  maxProductPrice: 10000,
  maxUniqueCartItems: 5,
  maxCartItems: 10,

  "invalid.credentials": "You have entered wrong credentials",
  "invalid.request.data": "Invalid credentials",
  "invalid.otp": "Verification code is incorrect",
  "not.found": "Not found",
  "not.allowed": "Cannot update profile while submitted for review",
  "invalid.token": "Auth token is not correct or you are missing auth token",
  "minimum.value": "Minimum value must be {}",
  "maximum.value": "Maximum value must be less than original amount",
  "invalid.phone": "Invalid phone number!",
  "order.driver.missing": "Driver is required",
  "order.driver.present": "Driver already present on order",
  "order.driver.assigned": "Driver is already assigned to an order",
  "invalid.iban": "Invalid IBAN Number",
  "maximum.decimals": "Maximum allowed decimals are {}",
  "conflict.error":
    "This operation can not be performed. Please contact system support",
  "address.state.not.supported": "Selected location is not supported",
  "invalid.acccount": "Could not resolve account name.",
  "coupon.not.applicable.on.some.products": "Not valid for your cart item(s)",

  "out.of.stock.product": "Product is out of stock",
  "coupon.invalid.country": "Invalid Coupon",
};
